import React from "react";
import Lottie from "lottie-react";
import animData from "constants/lottiesFiles/nodata.json";

const options = {
  loop: true,
  autoplay: true,
  animationData: animData,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice"
  }
};

function EmptyRecods({ message, labelClassName }) {
  return (
    <div className="d-flex flex-column w-100 text-center">
      <Lottie
        animationData={animData}
        style={{ width: "100%", height: 400 }}
        autoPlay
        loop
        options={options}
        className="mx-auto"
      />
      <span
        className={labelClassName}
        style={{
          color: "#FAA724",
          fontSize: 16,
          fontWeight: 700
        }}
      >
        {message}
      </span>
    </div>
  );
}

export default EmptyRecods;
